// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign from "./buhta_edo_sign_v1alpha1_document_sign.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const ListBatchSignDocumentsRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign_service.ml",
      660,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListBatchSignDocumentsResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign_service.ml",
      723,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const BulkSignDocumentsRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign_service.ml",
      783,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const BulkSignDocumentsResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign_service.ml",
      843,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.edo.sign.v1alpha1.ListBatchSignDocumentsRequest";
}

function make(idOpt, grid, param) {
  const id = idOpt !== undefined ? idOpt : "";
  return {
          id: id,
          grid: grid
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "grid",
            "grid"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          grid: Curry._2(merge_grid, t1.grid, t2.grid)
        };
}

function spec(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "grid",
                        "grid"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let.name,
                            make: $$let.make,
                            from_proto: $$let.from_proto,
                            from_proto_exn: $$let.from_proto_exn,
                            to_proto: $$let.to_proto,
                            to_proto$p: $$let.to_proto$p,
                            merge: $$let.merge,
                            to_json: $$let.to_json,
                            from_json_exn: $$let.from_json_exn,
                            from_json: $$let.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.id, param.grid);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, grid) {
  return {
          id: id,
          grid: grid
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.ListBatchSignDocumentsRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.grid);
  };
}

function constructor$1(id, grid) {
  return {
          id: id,
          grid: grid
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.ListBatchSignDocumentsRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListBatchSignDocumentsRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.edo.sign.v1alpha1.ListBatchSignDocumentsResponse";
}

function make$1(documentsOpt, param) {
  const documents = documentsOpt !== undefined ? documentsOpt : /* [] */0;
  return {
          documents: documents
        };
}

const $$let$1 = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSignIntent;

const merge_documents = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "documents",
            "documents"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$1(t1, t2) {
  return {
          documents: Curry._2(merge_documents, t1.documents, t2.documents)
        };
}

function spec$1(param) {
  const $$let = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSignIntent;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "documents",
                    "documents"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.documents);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(documents) {
  return {
          documents: documents
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.ListBatchSignDocumentsResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.documents);
  };
}

function constructor$3(documents) {
  return {
          documents: documents
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.ListBatchSignDocumentsResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListBatchSignDocumentsResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.edo.sign.v1alpha1.BulkSignDocumentsRequest";
}

function make$2(documentsOpt, param) {
  const documents = documentsOpt !== undefined ? documentsOpt : /* [] */0;
  return {
          documents: documents
        };
}

const $$let$2 = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSign;

const merge_documents$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "documents",
            "documents"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$2(t1, t2) {
  return {
          documents: Curry._2(merge_documents$1, t1.documents, t2.documents)
        };
}

function spec$2(param) {
  const $$let = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSign;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "documents",
                    "documents"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.documents);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(documents) {
  return {
          documents: documents
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.BulkSignDocumentsRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.documents);
  };
}

function constructor$5(documents) {
  return {
          documents: documents
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.BulkSignDocumentsRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, BulkSignDocumentsRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.edo.sign.v1alpha1.BulkSignDocumentsResponse";
}

function make$3(documentsOpt, param) {
  const documents = documentsOpt !== undefined ? documentsOpt : /* [] */0;
  return {
          documents: documents
        };
}

const $$let$3 = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSignResult;

const merge_documents$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "documents",
            "documents"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$3(t1, t2) {
  return {
          documents: Curry._2(merge_documents$2, t1.documents, t2.documents)
        };
}

function spec$3(param) {
  const $$let = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSignResult;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "documents",
                    "documents"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.documents);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(documents) {
  return {
          documents: documents
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.sign.v1alpha1.BulkSignDocumentsResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.documents);
  };
}

function constructor$7(documents) {
  return {
          documents: documents
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.sign.v1alpha1.BulkSignDocumentsResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, BulkSignDocumentsResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

const listBatchSignDocuments_0 = {
  name: ListBatchSignDocumentsRequest.name,
  make: ListBatchSignDocumentsRequest.make,
  from_proto: ListBatchSignDocumentsRequest.from_proto,
  from_proto_exn: ListBatchSignDocumentsRequest.from_proto_exn,
  to_proto: ListBatchSignDocumentsRequest.to_proto,
  to_proto$p: ListBatchSignDocumentsRequest.to_proto$p,
  merge: ListBatchSignDocumentsRequest.merge,
  to_json: ListBatchSignDocumentsRequest.to_json,
  from_json_exn: ListBatchSignDocumentsRequest.from_json_exn,
  from_json: ListBatchSignDocumentsRequest.from_json
};

const listBatchSignDocuments_1 = {
  name: ListBatchSignDocumentsResponse.name,
  make: ListBatchSignDocumentsResponse.make,
  from_proto: ListBatchSignDocumentsResponse.from_proto,
  from_proto_exn: ListBatchSignDocumentsResponse.from_proto_exn,
  to_proto: ListBatchSignDocumentsResponse.to_proto,
  to_proto$p: ListBatchSignDocumentsResponse.to_proto$p,
  merge: ListBatchSignDocumentsResponse.merge,
  to_json: ListBatchSignDocumentsResponse.to_json,
  from_json_exn: ListBatchSignDocumentsResponse.from_json_exn,
  from_json: ListBatchSignDocumentsResponse.from_json
};

const listBatchSignDocuments = [
  listBatchSignDocuments_0,
  listBatchSignDocuments_1
];

const bulkSignDocuments_0 = {
  name: BulkSignDocumentsRequest.name,
  make: BulkSignDocumentsRequest.make,
  from_proto: BulkSignDocumentsRequest.from_proto,
  from_proto_exn: BulkSignDocumentsRequest.from_proto_exn,
  to_proto: BulkSignDocumentsRequest.to_proto,
  to_proto$p: BulkSignDocumentsRequest.to_proto$p,
  merge: BulkSignDocumentsRequest.merge,
  to_json: BulkSignDocumentsRequest.to_json,
  from_json_exn: BulkSignDocumentsRequest.from_json_exn,
  from_json: BulkSignDocumentsRequest.from_json
};

const bulkSignDocuments_1 = {
  name: BulkSignDocumentsResponse.name,
  make: BulkSignDocumentsResponse.make,
  from_proto: BulkSignDocumentsResponse.from_proto,
  from_proto_exn: BulkSignDocumentsResponse.from_proto_exn,
  to_proto: BulkSignDocumentsResponse.to_proto,
  to_proto$p: BulkSignDocumentsResponse.to_proto$p,
  merge: BulkSignDocumentsResponse.merge,
  to_json: BulkSignDocumentsResponse.to_json,
  from_json_exn: BulkSignDocumentsResponse.from_json_exn,
  from_json: BulkSignDocumentsResponse.from_json
};

const bulkSignDocuments = [
  bulkSignDocuments_0,
  bulkSignDocuments_1
];

const V1alpha1_DocumentSignService = {
  ListBatchSignDocuments: {
    name: "/buhta.edo.sign.v1alpha1.DocumentSignService/ListBatchSignDocuments",
    package_name: "buhta.edo.sign.v1alpha1",
    service_name: "DocumentSignService",
    method_name: "ListBatchSignDocuments",
    $$Request: {
      name: ListBatchSignDocumentsRequest.name,
      make: ListBatchSignDocumentsRequest.make,
      from_proto: ListBatchSignDocumentsRequest.from_proto,
      from_proto_exn: ListBatchSignDocumentsRequest.from_proto_exn,
      to_proto: ListBatchSignDocumentsRequest.to_proto,
      to_proto$p: ListBatchSignDocumentsRequest.to_proto$p,
      merge: ListBatchSignDocumentsRequest.merge,
      to_json: ListBatchSignDocumentsRequest.to_json,
      from_json_exn: ListBatchSignDocumentsRequest.from_json_exn,
      from_json: ListBatchSignDocumentsRequest.from_json
    },
    $$Response: {
      name: ListBatchSignDocumentsResponse.name,
      make: ListBatchSignDocumentsResponse.make,
      from_proto: ListBatchSignDocumentsResponse.from_proto,
      from_proto_exn: ListBatchSignDocumentsResponse.from_proto_exn,
      to_proto: ListBatchSignDocumentsResponse.to_proto,
      to_proto$p: ListBatchSignDocumentsResponse.to_proto$p,
      merge: ListBatchSignDocumentsResponse.merge,
      to_json: ListBatchSignDocumentsResponse.to_json,
      from_json_exn: ListBatchSignDocumentsResponse.from_json_exn,
      from_json: ListBatchSignDocumentsResponse.from_json
    }
  },
  listBatchSignDocuments: listBatchSignDocuments,
  BulkSignDocuments: {
    name: "/buhta.edo.sign.v1alpha1.DocumentSignService/BulkSignDocuments",
    package_name: "buhta.edo.sign.v1alpha1",
    service_name: "DocumentSignService",
    method_name: "BulkSignDocuments",
    $$Request: {
      name: BulkSignDocumentsRequest.name,
      make: BulkSignDocumentsRequest.make,
      from_proto: BulkSignDocumentsRequest.from_proto,
      from_proto_exn: BulkSignDocumentsRequest.from_proto_exn,
      to_proto: BulkSignDocumentsRequest.to_proto,
      to_proto$p: BulkSignDocumentsRequest.to_proto$p,
      merge: BulkSignDocumentsRequest.merge,
      to_json: BulkSignDocumentsRequest.to_json,
      from_json_exn: BulkSignDocumentsRequest.from_json_exn,
      from_json: BulkSignDocumentsRequest.from_json
    },
    $$Response: {
      name: BulkSignDocumentsResponse.name,
      make: BulkSignDocumentsResponse.make,
      from_proto: BulkSignDocumentsResponse.from_proto,
      from_proto_exn: BulkSignDocumentsResponse.from_proto_exn,
      to_proto: BulkSignDocumentsResponse.to_proto,
      to_proto$p: BulkSignDocumentsResponse.to_proto$p,
      merge: BulkSignDocumentsResponse.merge,
      to_json: BulkSignDocumentsResponse.to_json,
      from_json_exn: BulkSignDocumentsResponse.from_json_exn,
      from_json: BulkSignDocumentsResponse.from_json
    }
  },
  bulkSignDocuments: bulkSignDocuments
};

const V1alpha1 = {
  ListBatchSignDocumentsRequest: ListBatchSignDocumentsRequest,
  ListBatchSignDocumentsResponse: ListBatchSignDocumentsResponse,
  BulkSignDocumentsRequest: BulkSignDocumentsRequest,
  BulkSignDocumentsResponse: BulkSignDocumentsResponse,
  DocumentSignService: V1alpha1_DocumentSignService
};

const Sign = {
  V1alpha1: V1alpha1
};

const Edo = {
  Sign: Sign
};

const Buhta = {
  Edo: Edo
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* ListBatchSignDocumentsRequest Not a pure module */
